import { ricsAndCompanyBranchLabels } from '../constants/branch-labels';
import { defineTreeFilter } from '../engine/descriptor';
import type { FilterDefinition } from '../engine/types';
import { FilterId, FilterType, type TreeFilter } from '../types/filters';

export const industryDescriptor = defineTreeFilter({
  definition: {
    id: FilterId.INDUSTRY,
    name: 'Industry',
    selectionListIds: ['rics_k10', 'rics_k400'],
    selections: [],
    branches: ricsAndCompanyBranchLabels,
    type: FilterType.TREE,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_INDUSTRY },
});

export const industryDefinition: FilterDefinition<TreeFilter> =
  industryDescriptor.definition;
